import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=7e184417&scoped=true&"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js&"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecifications.vue?vue&type=style&index=0&id=7e184417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e184417",
  null
  
)

export default component.exports